import { Link } from 'react-router-dom'
import { useDispatch } from "react-redux";
import { openPopup} from "../../store/popupSlice" 
import Breadcrumb from '../../component/Breadcrumb';

const breadcrumbData = {
  newClass:"center-breadcrumb white-breadcrumb",
  list:[
    {
      page:"Home",
      slug:"/"
    },
    {
      page:"Healthcare App Development",
      slug:""
    },
  ]
}

export default function HealthcareBanner() {
  const dispatch=useDispatch();
  return (
    <>
      <section className="custom-app-banner healthcare-banner header-gap">
        <div className="custom-banner-img">
          <img src="./assets/home/healthcare-banner.webp" alt="banner" className='img-responsive'/>
        </div>

        <div className="custom-app-head text-center">
          <label>AI-Powered Software</label>
          <h1 className="heading center-heading"> Development Partner  <br /><span>Empowering Innovators</span></h1>
          <p className="sub-heading">Build tailored software solutions with a team that truly <br/>comprehends your industry needs. 
          </p>
          <small>21 Days Free Trial | No Credit Card Required</small>
          <Breadcrumb breadcrumbData={breadcrumbData}/>
          <Link  onClick={() => dispatch(openPopup())}  className="default-btn animated-btn">
          book your free consultation
          </Link> 
        </div>
      </section>
    </>
  )
}
